import { injectGlobal, css } from "styled-components";

const fontList = [["regular", 500], ["medium", 600], ["bold", 700]];

function getTalPublicAssetsPath() {
  return typeof exports === "undefined"
    ? window["oetal"].env.talPublicAssetsPath
    : process.env["TAL_PUBLIC_ASSETS_PATH"];
}

const GorditaFontStyles = () => {
  return fontList.map(([style, weight]) => {
    const fontPrefix = `gordita${style}`;
    const fontName = `${fontPrefix}-webfont`;
    return css`
    @font-face {
      font-family: "gordita";
      src: url('${getTalPublicAssetsPath()}fonts/gordita/${fontName}.eot');
      src: url('${getTalPublicAssetsPath()}fonts/gordita/${fontName}.eot?#iefix') format('embedded-opentype'),
           url('${getTalPublicAssetsPath()}fonts/gordita/${fontName}.woff2') format('woff2'),
           url('${getTalPublicAssetsPath()}fonts/gordita/${fontName}.woff') format('woff'),
           url('${getTalPublicAssetsPath()}fonts/gordita/${fontName}.ttf') format('truetype'),
           url('${getTalPublicAssetsPath()}fonts/gordita/${fontName}.svg#${fontPrefix}') format('svg');
      font-weight: ${weight};
      font-style: ${style};
    }
  `;
  });
};

export const fontStyles = () => injectGlobal`
  ${GorditaFontStyles()}

  @font-face {
    font-family: "originicons";
    src: url('${getTalPublicAssetsPath()}fonts/originicons/originicons.eot');
    src: url('${getTalPublicAssetsPath()}fonts/originicons/originicons.eot?#iefix') format('embedded-opentype'),
         url('${getTalPublicAssetsPath()}fonts/originicons/originicons.woff') format('woff'),
         url('${getTalPublicAssetsPath()}fonts/originicons/originicons.ttf') format('truetype'),
         url('${getTalPublicAssetsPath()}fonts/originicons/originicons.svg') format('svg');
    font-weight: 400;
    font-style: normal;
  }
`;

export const resetStyles = () => injectGlobal`
  * {
    font-family: 'gordita', Arial, sans-serif;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }
  html, body, #root {
    height: 100%;
  }
  body {
    margin: 0;
    padding: 0;
  }
  body, h1, h2, h3, p, span {
    font-weight: normal;
  }
  #root {
    display: flex;
    flex-direction: column;
  }
`;

export const iconFontStyles = () => injectGlobal`
  @font-face{
      font-family: "Material Icons";
      src: url('${getTalPublicAssetsPath()}fonts/materialIcons/MaterialIcons-Regular.eot');
      src: url('${getTalPublicAssetsPath()}fonts/materialIcons/MaterialIcons-Regular.eot?#iefix') format('embedded-opentype'),
          url('${getTalPublicAssetsPath()}fonts/materialIcons/MaterialIcons-Regular.woff2') format('woff2'),
          url('${getTalPublicAssetsPath()}fonts/materialIcons/MaterialIcons-Regular.woff') format('woff'),
          url('${getTalPublicAssetsPath()}fonts/materialIcons/MaterialIcons-Regular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  .md-icon {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    /* Preferred icon size */
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;

    vertical-align: bottom;
    margin-right: 5px;

    direction: ltr;
    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;
    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;
    /* Support for IE. */
    font-feature-settings: 'liga';
  }
`;
